import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import img1 from '../../assets/images/svg/work-1.svg'
import img2 from '../../assets/images/svg/work-2.svg'
import img3 from '../../assets/images/svg/work-3.svg'
import img4 from '../../assets/images/svg/work-4.svg'


function Work02() {
    const { t } = useTranslation();
    const data = [
        {
            id: 1,
            img: img1,
            title: t('CHOOSE YOUR PLATFORM'),
            text: t('Selecttheplatform'),
        },
        {
            id: 2,
            img: img2,
            title: t('SELECT COIN AMOUNT'),
            text: t('Pick the amount of EA FC 26 Coins you need to enhance your Ultimate Team.'),
        },
        {
            id: 3,
            img: img3,
            title: t('COMPLETE THE PAYMENT'),
            text: t('Securely confirm your transaction using PayPal, crypto, or other available methods.'),
        },
        {
            id: 4,
            img: img4,
            title: t('RECEIVE YOUR COINS'),
            text: t('Enjoy instant and secure delivery of your EA FC 26 Coins directly to your account.'),
        },
    ];
    return (
        <section className="tf-work-ss">
    <div className="tf-container">
        <div className="row">
            <div className="col-md-12 ">
                <div className="title-ss wow fadeInUp" dir="rtl">
                    <h3 >{t('HOW')} <span className="mx-2 text-center" > {t('EA FC 26 COINS')} </span>  {t('WORK')}</h3>
                </div>
            </div>
            {data.map((item) => (
                <div key={item.id} className="col-xl-3 col-md-6">
                    <div 
                        className="tf-work style-2 wow fadeInUp"
                        style={{
                            height: '260px',          // Fixed height for the card
                            display: 'flex', 
                            flexDirection: 'column', 
                            // justifyContent: 'space-between',  // Space out content
                            alignItems: 'center', 
                            textAlign: 'center', 
                            padding: '20px',
                            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)', // Optional shadow
                        }}
                    >
                        {/* <div className="image">
                            <img src={item.img} alt={item.title} style={{ maxHeight: '100px', marginBottom: '5px' }} />
                        </div> */}
                        <h5 className="step" style={{ fontSize: '20px', fontWeight: 'bold', marginBottom: '15px' }}>{t('STEP')} {item.id}</h5>
                        <h4 className="title" style={{ fontSize: '18px', fontWeight: 'bold', marginBottom: '5px' }}>
                            <Link to="#">{item.title}</Link>
                        </h4>
                        <p style={{ fontSize: '14px', color: '#666', margin: 0 }}>{item.text}</p>
                    </div>
                </div>
            ))}
        </div>
    </div>
</section>


    );
}

export default Work02;